import { indigo } from '@mui/material/colors';
import type { Components, Theme } from '@mui/material/styles';

import { BASE_TRANSITION } from '../constants';

const MuiTabs: Components<Theme>['MuiTabs'] = {
  styleOverrides: {
    /**
     * Корневые стили табов.
     *
     * Радиус — системный `shape.borderL` (16px), а не прежние 10px: 10 выбивались
     * из общего скругления карточек и плашки варианта `big`, и на экранах, где
     * оба ряда табов стоят рядом, разница читалась как две разные системы.
     * @param root0 Пропсы табов
     * @param root0.theme Тема
     */
    root: ({ theme }) => ({
      backgroundColor: '#EEF0FA',
      borderRadius: theme.shape.borderL,
      minHeight: '40px',
      '& .MuiTabs-indicator': {
        height: '100%',
        borderRadius: theme.shape.borderL,
        backgroundColor: indigo[800],
        transition: BASE_TRANSITION
      }
    })
  }
};

const MuiTab: Components<Theme>['MuiTab'] = {
  defaultProps: {
    disableRipple: true
  },
  styleOverrides: {
    /**
     * Корневые стили таба
     * @param root0 Пропсы таба
     * @param root0.theme Тема
     */
    root: ({ theme }) => ({
      textTransform: 'none',
      fontSize: '14px',
      fontWeight: 400,
      // Тот же системный радиус, что и у плашки: пилюля активного таба обязана
      // повторять её скругление, иначе внутри 16px-плашки лежит 10px-элемент
      borderRadius: theme.shape.borderL,
      minHeight: '40px',
      zIndex: 1,
      color: theme.palette.primary.main,
      transition: BASE_TRANSITION,
      '&:hover': {
        backgroundColor: indigo[100]
      },
      '&.Mui-selected': {
        color: theme.palette.common.white,
        backgroundColor: 'transparent',
        transition: 'none'
      }
    })
  }
};

export const tab = {
  MuiTabs,
  MuiTab
};
